import { render, staticRenderFns } from "./UgiSwitch.vue?vue&type=template&id=5ab3d738&"
import script from "./UgiSwitch.vue?vue&type=script&lang=js&"
export * from "./UgiSwitch.vue?vue&type=script&lang=js&"
import style0 from "./UgiSwitch.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports